import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { bailiffDocumentProcessCompleteSelector } from "store/bailiff/bailiff/document/bailiff_document.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const FLOWS = {
  LOADING: "loading",
  FINISH: "finish",
};
export const useLoadingFinishFlow = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [flow, setFlow] = useState(FLOWS.LOADING);
  // -------------------------- REDUX ---------------------------
  const completed = useSelector(bailiffDocumentProcessCompleteSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (completed === false) {
      setFlow(FLOWS.LOADING);
    }
    if (completed === true) {
      setFlow(FLOWS.FINISH);
    }
  }, [completed]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { flow };
};
